import React from 'react';
import { getUserName } from '../utils/userUtils';

export default function VoteButton({
  votes = 0,
  hasVoted = false,
  onVote,
  votedBy = [],
  users = [],
  itemType = "item"
}) {
  const tooltipText = votedBy.length > 0
    ? `Liked by: ${votedBy.map(v => getUserName(users, v)).join(', ')}`
    : (hasVoted ? "Remove vote" : `Vote for this ${itemType}`);

  return (
    <button
      onClick={(e) => {
        if (e && typeof e.stopPropagation === 'function') {
          e.stopPropagation();
        }
        if (onVote) onVote();
      }}
      style={{
        background: hasVoted ? 'rgba(192, 57, 43, 0.12)' : 'rgba(252, 249, 245, 0.03)',
        border: hasVoted ? '1px solid rgba(192, 57, 43, 0.3)' : '1px solid rgba(252, 249, 245, 0.08)',
        borderRadius: '0px',
        padding: '4px 10px',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        fontSize: '0.8rem',
        color: hasVoted ? 'var(--color-danger, #c0392b)' : 'var(--color-text-muted)',
        fontWeight: '600',
        transition: 'all 0.2s ease',
        fontFamily: 'var(--font-body)'
      }}
      title={tooltipText}
    >
      ❤️ {votes}
    </button>
  );
}
